module.exports = "/_next/static/files/a90a51f1c0f6775d2fcc53d8f50448f9.svg";